/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import McAnswerParam from './McAnswerParam';
import McMcTranslationParam from './McMcTranslationParam';

/**
 * The McCreateMcParam model module.
 * @module model/McCreateMcParam
 * @version 1.0
 */
class McCreateMcParam {
    /**
     * Constructs a new <code>McCreateMcParam</code>.
     * @alias module:model/McCreateMcParam
     */
    constructor() { 
        
        McCreateMcParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McCreateMcParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McCreateMcParam} obj Optional instance to populate.
     * @return {module:model/McCreateMcParam} The populated <code>McCreateMcParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McCreateMcParam();

            if (data.hasOwnProperty('answers')) {
                obj['answers'] = ApiClient.convertToType(data['answers'], [McAnswerParam]);
            }
            if (data.hasOwnProperty('explanation')) {
                obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
            }
            if (data.hasOwnProperty('question')) {
                obj['question'] = ApiClient.convertToType(data['question'], 'String');
            }
            if (data.hasOwnProperty('translation')) {
                obj['translation'] = ApiClient.convertToType(data['translation'], {'String': McMcTranslationParam});
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/McAnswerParam>} answers
 */
McCreateMcParam.prototype['answers'] = undefined;

/**
 * @member {String} explanation
 */
McCreateMcParam.prototype['explanation'] = undefined;

/**
 * @member {String} question
 */
McCreateMcParam.prototype['question'] = undefined;

/**
 * @member {Object.<String, module:model/McMcTranslationParam>} translation
 */
McCreateMcParam.prototype['translation'] = undefined;






export default McCreateMcParam;

